import { t } from 'i18next';
import { CommonFlex, CommonText, Container } from 'styledComponents/common';

import no_data from '../../../assets/img/no_data.svg';
import {
  DashBoardOverviewColumnCardsContainer,
  DashBoardOverviewColumnContainer,
} from '../../../components/DashboardCards/cardStyles';
import PieChart from './pieChart';

const TransactionReportColumn = ({ title, data }) => {
  console.log(
    '🚀 ~ transactionReportColumn.jsx:12 ~ title, data:',
    title,
    data,
  );
  return (
    <DashBoardOverviewColumnContainer>
      <CommonText fontSize="16px" fontWeight="600">
        {t(title)}
      </CommonText>
      <DashBoardOverviewColumnCardsContainer>
        {data?.length > 0 ? (
          data.map((item, index) => (
            <Container
              key={index}
              style={{ marginBottom: '15px', padding: '10px' }}
            >
              <CommonFlex justifyContent="space-between">
                <CommonText
                  fontSize="14px"
                  fontWeight="500"
                  margin="0 0 10px 0"
                >
                  {item.label}
                </CommonText>
              </CommonFlex>
              <CommonFlex
                alignItems="center"
                justifyContent="center"
                style={{ margin: '15px 0', height: 'auto' }}
              >
                <PieChart
                  outerChartData={{
                    readinessPercentage: item.value,
                  }}
                />
              </CommonFlex>
            </Container>
          ))
        ) : (
          <CommonFlex justifyContent="center">
            <img src={no_data} alt="" width="50%" />
          </CommonFlex>
        )}
      </DashBoardOverviewColumnCardsContainer>
    </DashBoardOverviewColumnContainer>
  );
};

export default TransactionReportColumn;
